module.exports = __webpack_public_path__ + "img/20201005_115109.2a0f6033.jpg";